import type { SectionsIds } from '@/types/catalog'
import type { SubdepartmentWithFamilies } from '@/types/treeViewTypes'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { getFamilies } from '@/api'
import { queryKeys } from '@/query/queryKeys'

export function useFetchFamilies() {
  const queryClient = useQueryClient()
  const [isPending, setIsPending] = useState(false)

  const fetchFamilies = async (
    season: string,
    ids: SectionsIds,
    onSuccess: (data: SubdepartmentWithFamilies) => void,
  ) => {
    setIsPending(true)
    try {
      const data = await queryClient.fetchQuery({
        queryKey: queryKeys.family(ids.subdepartmentId, season),
        queryFn: () => getFamilies<SubdepartmentWithFamilies>(
          season,
          ids.universeId,
          ids.departmentId,
          ids.subdepartmentId,
        ),
        staleTime: 1000 * 60 * 15,
      })
      if (data) {
        onSuccess({
          ...data,
          families: data.families.toSorted((a, b) => Number(a.id) - Number(b.id)),
        })
      }
    }
    finally {
      setIsPending(false)
    }
  }

  return { fetchFamilies, isPending }
}
